import {
  ALERT_MESSAGE_TYPE,
  isMobileAtom,
  LoginModal,
  PAGE_NAME,
  useGetReservation,
  useRecoil,
} from '@orcar/common-d2c';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import D2CReservationDetail from './components/D2CReservationDetail';
import SkeletonReservationDetail from './components/SkeletonReservationDetail';

const ReservationDetailPage = () => {
  const navigate = useNavigate();
  const { reservationId } = useParams();
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const {
    data: reservationData,
    isLoading: isLoadingReservation,
    error,
  } = useGetReservation(reservationId);

  useEffect(() => {
    if (error) {
      if (error.response?.data.statusCode === 401) {
        alert(ALERT_MESSAGE_TYPE.UNAUTHORIZE_ACCESS);
        setIsLoginModalOpen(true);
      } else if (error.response?.data.statusCode === 403) {
        alert(ALERT_MESSAGE_TYPE.INVALID_TOKEN);
        navigate(PAGE_NAME.index, { replace: true });
      } else {
        alert(ALERT_MESSAGE_TYPE.INVALID_RESERVATION);
        navigate(PAGE_NAME.index, { replace: true });
      }
    }
  }, [error]);

  if (isLoadingReservation) return <SkeletonReservationDetail />;

  return (
    <>
      {reservationData && (
        <D2CReservationDetail
          reservationData={reservationData}
          preReservation={reservationData.preReservation}
        />
      )}
      <LoginModal
        platform={isMobile ? 'mobile' : 'desktop'}
        isOpen={isLoginModalOpen}
        originUrl={import.meta.env.VITE_ORIGIN_URL}
        onClose={() => {
          setIsLoginModalOpen(false);
        }}
      />
    </>
  );
};

export default ReservationDetailPage;
